(() => {
  const cfg = window.__ISO_SWATCH_FILTER__;
  if (!cfg || !cfg.enabled) return;

  const log = (...a) => console.log("[ISO FILTER]", ...a);

  let productJson = null;
  let idx = null;

  // --- Mémoire: dernière swatch Modèle par valeur de l'option primaire (Isotherme/Non Isotherme)
  const memKey = (primaryVal) => `isoFilter:lastDep:${cfg.sectionId}:${(primaryVal || "").trim()}`;
  const saveLastDep = (primaryVal, depVal) => {
    try { localStorage.setItem(memKey(primaryVal), String(depVal || "").trim()); } catch(e) {}
  };
  const loadLastDep = (primaryVal) => {
    try { return (localStorage.getItem(memKey(primaryVal)) || "").trim(); } catch(e) { return ""; }
  };

  function getMainRoot() {
    return (
      document.getElementById(`MainProduct-${cfg.sectionId}`) ||
      document.querySelector(`product-info[data-section="${cfg.sectionId}"]`) ||
      document.querySelector("product-info") ||
      document
    );
  }

  function getVariantSelects() {
    return document.querySelector(`variant-selects[data-section="${cfg.sectionId}"]`);
  }

  async function fetchProductJSON() {
    const link = document.querySelector('link[rel="canonical"]');
    const url = link ? link.href : location.href.split("?")[0].split("#")[0];
    const jsonUrl = url.replace(/\/$/, "") + ".js";
    const res = await fetch(jsonUrl, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Fetch product.js failed: " + res.status);
    return await res.json();
  }

  function getOptionNames(p) {
    const opts = p.options || [];
    if (!opts.length) return [];
    if (typeof opts[0] === "string") return opts.map(s => String(s).trim());
    if (typeof opts[0] === "object" && opts[0] && "name" in opts[0]) {
      return opts.map(o => String(o.name || "").trim());
    }
    return [];
  }

  function findOptionIndexes(p) {
    const names = getOptionNames(p);
    return {
      names,
      primaryIndex: names.findIndex(n => n === cfg.primaryOptionName),
      depIndex: names.findIndex(n => n === cfg.dependentOptionName),
    };
  }

  function getVariantOptionAt(v, index) {
    if (!v) return "";
    if (Array.isArray(v.options)) return String(v.options[index] ?? "").trim();
    const key = "option" + (index + 1);
    if (v[key] != null) return String(v[key]).trim();
    return "";
  }

  // ✅ ton thème a parfois "\n" => on matche en startsWith
  function getSelectedPrimaryValue(root, primaryIndex) {
    const primaryNamePrefix = `${cfg.primaryOptionName}-${primaryIndex + 1}`;

    // radio/button
    const radios = [...root.querySelectorAll(`input[type="radio"]`)];
    const checked = radios.find(r => (r.getAttribute("name") || "").trim().startsWith(primaryNamePrefix) && r.checked);
    if (checked) return String(checked.value).trim();

    // dropdown
    const select = root.querySelector(`select[name="options[${cfg.primaryOptionName}]"]`);
    if (select) return String(select.value).trim();

    return null;
  }

  function applyFilterNow() {
    const vs = getVariantSelects();
    const root = vs || getMainRoot();

    if (!productJson || !idx) return;

    const { primaryIndex, depIndex, names } = idx;
    if (primaryIndex < 0 || depIndex < 0) {
      log("Options not found", names);
      return;
    }

    const primaryValue = getSelectedPrimaryValue(root, primaryIndex);
    if (!primaryValue) return;

    const variants = productJson.variants || [];
    if (!variants.length) return;

    const allowed = new Set();
    for (const v of variants) {
      const p = getVariantOptionAt(v, primaryIndex);
      const d = getVariantOptionAt(v, depIndex);
      if (p === primaryValue && d) allowed.add(d);
    }

    // Fail-safe : si allowed vide, on ne casse rien
    if (allowed.size === 0) return;

    const depPrefix = `${cfg.dependentOptionName}-${depIndex + 1}`;
    const depInputs = [...root.querySelectorAll(`input[type="radio"]`)]
      .filter(i => (i.getAttribute("name") || "").trim().startsWith(depPrefix));

    // --- 1) Cache / show + si un input interdit est checked => on le décoche
    let hadChecked = false;
    depInputs.forEach(input => {
      const val = String(input.value).trim();
      const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      const show = allowed.has(val);

      if (show) {
        input.style.display = "";
        if (label) label.style.display = "";
      } else {
        if (input.checked) {
          hadChecked = true;
          input.checked = false;
        }
        input.style.display = "none";
        if (label) label.style.display = "none";
      }
    });

    // --- 2) Auto-select si rien n’est sélectionné (ou si on a dû décocher)
    const stillChecked = depInputs.find(i => i.checked);
    if (!stillChecked) {
      // a) essaye la dernière sélection de ce groupe
      const last = loadLastDep(primaryValue);
      let toSelect = null;

      if (last) {
        toSelect = depInputs.find(i => String(i.value).trim() === last && allowed.has(String(i.value).trim()));
      }

      // b) sinon première autorisée
      if (!toSelect) {
        toSelect = depInputs.find(i => allowed.has(String(i.value).trim()));
      }

      if (toSelect) {
        toSelect.checked = true;
        // IMPORTANT: déclenche le comportement Dawn (update prix, variant id, etc.)
        toSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  // ✅ Dawn réécrit le DOM => réappliquer après
  function scheduleApply() {
    applyFilterNow();
    requestAnimationFrame(() => applyFilterNow());
    setTimeout(() => applyFilterNow(), 60);
    setTimeout(() => applyFilterNow(), 200);
  }

  function bindGlobalListeners() {
    // 1) Quand on change l’option primaire -> refiltrer + auto-select
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      const name = (t.getAttribute && t.getAttribute("name")) ? t.getAttribute("name") : "";

      if (name && String(name).includes(cfg.primaryOptionName)) {
        scheduleApply();
        return;
      }

      // 2) Quand on clique une swatch Modèle -> mémoriser pour ce groupe (isotherme/non)
      if (name && String(name).includes(cfg.dependentOptionName) && t.value != null) {
        const vs = getVariantSelects();
        const root = vs || getMainRoot();
        const { primaryIndex } = idx || {};
        if (primaryIndex == null || primaryIndex < 0) return;

        const primaryValue = getSelectedPrimaryValue(root, primaryIndex);
        if (!primaryValue) return;

        saveLastDep(primaryValue, t.value);
      }
    }, true);

    // Certains builds Dawn publient aussi ces events
    ["variant:change", "variant:select", "product:variant-change"].forEach(evt => {
      document.addEventListener(evt, scheduleApply, true);
    });
  }

  function observeRerenders() {
    const main = getMainRoot();
    const mo = new MutationObserver(() => {
      scheduleApply();
    });
    mo.observe(main, { childList: true, subtree: true });
  }

  async function init() {
    productJson = await fetchProductJSON();
    idx = findOptionIndexes(productJson);

    bindGlobalListeners();
    observeRerenders();

    scheduleApply();

    log("enabled", {
      optionsFound: idx.names,
      primaryIndex: idx.primaryIndex,
      depIndex: idx.depIndex
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init().catch(console.error));
  } else {
    init().catch(console.error);
  }
})();
